import api from './api';

export const conversationService = {
  getAll: () => api.get('/conversations'),
  getById: (id) => api.get(`/conversations/${id}`),
  send: (data) => api.post('/conversations/send', data),
  getUnreadCount: () => api.get('/conversations/unread-count'),
};
